export const TIMING = {
  PROCESS_LIST_REFRESH_INTERVAL_MS: 60000,
  HEAP_SIZE_POLL_INTERVAL_MS: 1000,
  TOOLTIP_HIDE_DELAY_MS: 1000,
  CAMERA_POSITION_CHECK_THROTTLE_MS: 500,
  CAMERA_MESH_CHANGE_DEBOUNCE_MS: 400,
  VIEWFINDER_COLOR_UPDATE_DELAY_MS: 500,
  PROCESSING_FORM_DEBOUNCE_MS: 500,
  SRS_DROPDOWN_SEARCH_DEBOUNCE_MS: 300,
  THICKNESS_FORM_DEBOUNCE_MS: 100,
  UI_SETTINGS_DEBOUNCE_MS: 700,
  PHOTOS_CAROUSEL_DEBOUNCE_MS: 100,
  LAYER_DETAILS_DEBOUNCE_MS: 10,
} as const;
